import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getUserInformation } from "../actions/userActions";
import {
  getBuyerOrders,
  getBuyerOrdersCompleted,
} from "../actions/orderActions";
import ProfileNavbar from "../components/Profile_Components/ProfileNavbar";
import ProfileBuying from "../components/Profile_Components/ProfileBuying";
import BreadcrumbLocation from "../components/BreadcrumbLocation";
const ProfileBuyingScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userLogin = useSelector((state) => state.userLogin);
  const { isAuthenticated } = userLogin;
  useEffect(() => {
    if (isAuthenticated === true) {
      dispatch(getUserInformation());
      dispatch(getBuyerOrders());
      dispatch(getBuyerOrdersCompleted());
    }
    if (isAuthenticated === false) {
      navigate(`/login?redirect=${location.pathname}`);
    }
  }, [isAuthenticated]);
  return (
    <>
      <BreadcrumbLocation
        location={["ReShup", "Settings", "My Orders"]}
      ></BreadcrumbLocation>
      <div className="container d-flex flex-row mt-4">
        <ProfileNavbar></ProfileNavbar>

        <ProfileBuying></ProfileBuying>
      </div>
    </>
  );
};

export default ProfileBuyingScreen;
